const ordersFilter = () => {
	const lkOrders = document.querySelector('.js-lk-orders');
	const filterList = document.querySelector('.js-orders-filters-slider');

	if (!filterList) return;

	const url = new URL(window.location.href);
	const searchParams = url.searchParams;
	const filterSearchParam = searchParams.get('filter');

	if (filterSearchParam) {
		const filterItem = filterList.querySelector(`[data-filter=${filterSearchParam}]`);

		changeActiveFilter(filterItem);
		renderList(filterSearchParam);
	}

	lkOrders && lkOrders.classList.add('show');

	filterList.addEventListener('click', filterListHandler);

	function filterListHandler(e) {
		const filterItem = e.target.closest('[data-filter]');

		if (!filterItem) return;
		const filter = filterItem.dataset.filter;

		changeActiveFilter(filterItem);

		url.searchParams.set('filter', filter);
		history.pushState({}, document.title, url.href);

		renderList(filter);
	}

	function changeActiveFilter(filterItem) {
		const currentActiveFilter = filterList.querySelector('.active[data-filter]');

		if (currentActiveFilter === filterItem) return;

		currentActiveFilter && currentActiveFilter.classList.remove('active');
		filterItem && filterItem.classList.add('active')
	}

	function renderList(filter) {
		const itemList = document.querySelectorAll(`.js-orders-filter-item`);

		if (filter === 'all') {
			itemList.forEach(item => item.classList.remove('hide'));
		} else {
			itemList.forEach(item => {
				const itemFilter = item.dataset.filter;

				if (itemFilter !== filter) {
					item.classList.add('hide');
				} else if (itemFilter === filter && item.classList.contains('hide')) {
					item.classList.remove('hide');
				}
			})
		}
	}
}
